import React from 'react';
import './admin-game-downloads.styles.scss';
import { getCollectionFromFirestore, getQueryFromFirestore, getQueryFromRtDb, getUniqueDocumentFromFirestore } from '@/utils/getDataFromDbSimplified';

const AdminGameDownloads = ({
  gameData,
}) => {

  async function getDownloadData(type) {
    console.log(gameData);
    if (type === 'gameData') {
      processDataForDownload({...gameData});
      return;
    }
    else if (type === 'gameElementShort') {
      getCollectionFromFirestore({
        'path': `games/${gameData.gameId}/gameElementsShortList`,
        'once': true,
        'callback': handleData,
      });
      function handleData(data) {
        let formattedData = {};
        for (let doc of Object.values(data)) {
          formattedData = {
            ...formattedData,
            ...doc
          }
        }
        processDataForDownload(formattedData);
      }
      return;
    }
    else if (type === 'gameElementsLong') {
      getCollectionFromFirestore({
        'path': `games/${gameData.gameId}/gameElements`,
        'once': true,
        'callback': processDataForDownload,
      });
    }
    else if (type === 'pendingActionItems') {
      getQueryFromFirestore({
        'path': `games/${gameData.gameId}/actionItems`,
        'queryArray': [{
          'field': 'status',
          'operator': '==',
          'value': 'pending',
        }],
        'once': true,
        'callback': processDataForDownload,
      });
    } 
    else if (type === 'completeActionItems') {
      getQueryFromFirestore({
        'path': `games/${gameData.gameId}/actionItems`,
        'queryArray': [{
          'field': 'status',
          'operator': '!=',
          'value': 'pending',
        }],
        'once': true,
        'callback': processDataForDownload,
      });
    } else if (type === 'activityRecords') {
      getCollectionFromFirestore({
        'path': `games/${gameData.gameId}/activityRecords`,
        'once': true,
        'callback': processDataForDownload,
      });
    } else if (type === 'playerDocs') {
      getQueryFromRtDb({
        'path': `games/${gameData.gameId}/playerDocs`,
        'once': true,
        'callback': processDataForDownload,
      })
    } else if (type === 'leaderList') {
      getQueryFromRtDb({
        'path': `games/${gameData.gameId}/leaderList`,
        'once': true,
        'callback': processDataForDownload,
      });
    } else if (type === 'passcodes') {
      getUniqueDocumentFromFirestore({
        'path': `games/${gameData.gameId}/passcodes/${gameData.gameId}-passcodes`,
        'once': true,
        'callback': processDataForDownload,
      })
    } else if (type === 'teamMembers') {
      getUniqueDocumentFromFirestore({
        'path': `games/${gameData.gameId}/teamMembers/${gameData.gameId}-teamMembers`,
        'once': true,
        'callback': processDataForDownload,
      })
    } else if (type === 'completePlayerData') {
      getCollectionFromFirestore({
        'path': `games/${gameData.gameId}/players`,
        'once': true,
        'callback': processDataForDownload,
      })
    } else if (type === 'gameStats') {
      getUniqueDocumentFromFirestore({
        'path': `games/${gameData.gameId}/gameStats/${gameData.gameId}-gameStats`,
        'once': true,
        'callback': processDataForDownload,
      })
    } else if (type === 'messages') {
      getCollectionFromFirestore({
        'path': `games/${gameData.gameId}/messages`,
        'once': true,
        'callback': processDataForDownload,
      })
    }
    
    function processDataForDownload(data) {
      console.log(data);
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${gameData.name ?? gameData.id}-game-data.json`;
      a.click();
      URL.revokeObjectURL(url);
    }
  }


  return (
    <div className='admin-game-downloads'>
      <button 
        className='g-button med-btn'
        onClick={() => getDownloadData('gameData')}>
        Download Game Data
      </button>
      <button
        className='g-button med-btn'
        onClick={() => getDownloadData('gameStats')}>
        Download Game Stats
      </button>
      <button 
        className='g-button med-btn'
        onClick={() => getDownloadData('gameElementShort')}>
        Download Game Elements Short List
      </button>
      <button 
        className='g-button med-btn'
        onClick={() => getDownloadData('gameElementsLong')}>
        Download Full Game Elements Data
      </button>
      <button 
        className='g-button med-btn'
        onClick={() => getDownloadData('pendingActionItems')}>
        Download Pending Action Items
      </button>
      <button
        className='g-button med-btn'
        onClick={() => getDownloadData('completeActionItems')}>
        Download Complete Action Items
      </button>
      <button 
        className='g-button med-btn'
        onClick={() => getDownloadData('activityRecords')}>
        Download Activity Records
      </button>
      <button 
        className='g-button med-btn'
        onClick={() => getDownloadData('playerDocs')}>
        Download Player Docs
      </button>
      <button 
        className='g-button med-btn'
        onClick={() => getDownloadData('leaderList')}>
        Download Leader List
      </button>
      <button 
        className='g-button med-btn'
        onClick={() => getDownloadData('passcodes')}>
        Download Passcodes
      </button>
      <button 
        className='g-button med-btn'
        onClick={() => getDownloadData('teamMembers')}>
        Download Team Members
      </button>
      <button 
        className='g-button med-btn'
        onClick={() => getDownloadData('completePlayerData')}>
        Download Complete Player Data
      </button>
      <button 
        className='g-button med-btn'
        onClick={() => getDownloadData('messages')}>
        Download Messages
      </button>
    </div>
  )
}

export default AdminGameDownloads